import React from "react";
import { Tag, HandCoins, Pointer, Truck, ShieldCheck, ReceiptText } from "lucide-react";
import { useTheme } from "../../../contexts/ThemeContext";

const WhyChooseUsSimple = () => {
  const { isDark } = useTheme();

  const iconColor = isDark ? "text-blue-500" : "text-blue-600";

  const features = [
    {
      icon: <Tag size={32} className={iconColor} />,
      title: "Best Prices",
      desc: "Save up to 60% compared to retail prices on premium refurbished laptops",
    },
    {
      icon: <ShieldCheck size={32} className={iconColor} />,
      title: "Quality Certified",
      desc: "Every device undergoes a rigorous 49-point performance and hardware inspection",
    },
    {
      icon: <ReceiptText size={32} className={iconColor} />,
      title: "12-Month Warranty",
      desc: "Enjoy complete peace of mind with our hassle-free, full-year coverage",
    },
    {
      icon: <Truck size={32} className={iconColor} />,
      title: "Free Express Delivery",
      desc: "Fast and fully insured shipping straight to your doorstep across India",
    },
    {
      icon: <Pointer size={32} className={iconColor} />,
      title: "14-Day Returns",
      desc: "Completely risk-free shopping with our no-questions-asked return policy",
    },
    {
      icon: <HandCoins size={32} className={iconColor} />,
      title: "Trusted by 20,000+",
      desc: "Serving thousands of students, creators, and growing startups every month",
    },
  ];

  return (
    <section className={`pt-4 pb-12 px-4 md:px-8 lg:px-12 ${isDark ? "bg-black" : "bg-white"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className={`text-3xl md:text-4xl font-extrabold tracking-tight ${isDark ? "text-white" : "text-black"}`}>
            Why Choose <span className={isDark ? "text-blue-500" : "text-blue-600"}>Us</span>
          </h2>
          <div className={`w-16 h-1 mx-auto mt-4 rounded-full ${isDark ? "bg-blue-500" : "bg-blue-600"}`}></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-12 gap-x-8">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start gap-4">
              <div className="flex-shrink-0 mt-1">
                {feature.icon}
              </div>
              <div>
                <h3 className={`text-lg font-bold mb-1 ${isDark ? "text-white" : "text-black"}`}>
                  {feature.title}
                </h3>
                <p className={`text-sm leading-relaxed ${isDark ? "text-gray-300" : "text-gray-700"}`}>
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSimple;
